import { defineComponent, inject, ref, computed, onMounted, createElementBlock, openBlock, createBlock, createElementVNode, resolveDynamicComponent, withCtx, unref, renderSlot, createVNode, normalizeClass } from 'vue';
import { accordionInjectionKey } from './basler-components.es424.js';
import _sfc_main$1 from './basler-components.es81.js';
/* empty css                       */

const _hoisted_1 = ["id"];
const _hoisted_2 = ["id", "aria-controls", "aria-expanded"];
const _hoisted_3 = ["id", "aria-labelledby"];
const _hoisted_4 = { class: "accordion-item__panel-inner" };
const _hoisted_5 = { class: "accordion-item__content" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AccordionItem",
  props: {
    uid: { default: "" },
    isOpen: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const { itemInit, triggerClick, triggerKeydown, accordionListState } = inject(accordionInjectionKey) || {};
    const id = ref("");
    const headingLevel = ref(3);
    const currentItemState = computed(
      () => accordionListState ? accordionListState.find((panel) => panel.uid === id.value)?.isActive : false
    );
    onMounted(() => {
      if (!itemInit) {
        console.error("⚠️ No `initItem` function provided, please use AccordionItem only inside AccordionComponent");
        return;
      }
      const { uid, itemHeadingLevel } = itemInit({
        uid: props.uid,
        openOnInit: props.isOpen
      });
      id.value = uid;
      headingLevel.value = itemHeadingLevel;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("article", {
        class: "accordion-item",
        id: `accordion-item-${id.value}`
      }, [
        (openBlock(), createBlock(resolveDynamicComponent(`h${headingLevel.value}`), { class: "accordion-item__header" }, {
          default: withCtx(() => [
            createElementVNode("button", {
              id: `accordion-trigger-${id.value}`,
              type: "button",
              class: "accordion-item__trigger",
              "aria-controls": `accordion-panel-${id.value}`,
              "aria-expanded": currentItemState.value,
              onClick: _cache[0] || (_cache[0] = ($event) => unref(triggerClick) && unref(triggerClick)(id.value)),
              onKeydown: _cache[1] || (_cache[1] = //@ts-ignore
              (...args) => unref(triggerKeydown) && unref(triggerKeydown)(...args))
            }, [
              renderSlot(_ctx.$slots, "title"),
              createVNode(_sfc_main$1, {
                name: "arrow-down",
                "scale-factor": 0.8
              })
            ], 40, _hoisted_2)
          ]),
          _: 3
        })),
        createElementVNode("div", {
          id: `accordion-panel-${id.value}`,
          role: "region",
          class: normalizeClass(["accordion-item__panel", { "is-active": currentItemState.value }]),
          "aria-labelledby": `accordion-trigger-${id.value}`
        }, [
          createElementVNode("div", _hoisted_4, [
            createElementVNode("div", _hoisted_5, [
              renderSlot(_ctx.$slots, "default")
            ])
          ])
        ], 10, _hoisted_3)
      ], 8, _hoisted_1);
    };
  }
});

export { _sfc_main as default };
